
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/crash-course",
      function () {
        return require("private-next-pages/section/crash-course/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/crash-course"])
      });
    }
  